class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}